import { UserTagAction } from "./user-tag.action";

export interface UserTagState {
  tags: Tag[];
  pending: boolean,
  isLoaded: boolean;
  userTagError: string;
}

export interface Tag {
  key: string;
  value: string;
}

export const initialState: UserTagState = {
  tags: [],
  pending: false,
  isLoaded: false,
  userTagError: ""
};

export function UserTagReducer(
  state: UserTagState = initialState,
  action?: UserTagAction
): UserTagState {
  switch (action.type) {
    case UserTagAction.getUserTag: {
      return {
        ...state,
        ...{ pending: true }
      }
    }

    case UserTagAction.getUserTagSuccess: {
      const userTagResponse = action.payload;
      return {
        ...state,
        ...{
          tags: [... getTagsList(userTagResponse) ],
          pending: false,
          isLoaded: true,
        }
      }
    }

    case UserTagAction.getUserTagError: return {
      ...state,
      ...{
        pending: false,
        isLoaded: true,
        userTagError: action.payload,
      }
    }

    default:
      return state;
  }
}

export function getTagsList(tags): Tag[] {
  if (!Array.isArray(tags)) {
      return [] as Tag[];
  }

  const tagsList: Tag[] = [];
  tags.forEach((element) => {
      tagsList.push({
          key: element.key,
          value: element.value,
      } as Tag);
  });

  return tagsList;
}
